const adminPageConstants = {
  adminPage: {
    tabs: {
      userList: 0,
      roleList: 1,
      instrumentationList: 2,
      siteList: 3,
      mteTypeList: 4,
      notificationBanner: 5,
      notificationTemplates: 6,
    },
  },
  adminCookies: {
    admin_selected_tab: 'admin_selected_tab',
  },
};
export default adminPageConstants;
